import React from 'react'
import PropTypes from 'prop-types'

import { translate } from 'parking-react-common'

import { Field } from 'redux-form'

import { ui } from '../redux'

import Panel from '../components/Panel'
import Table from '../components/Table'
import Input from '../components/Input'
import Button from '../components/Button'
import TimePickerInput from '../components/TimePickerInput'
import DateRangePickerInput from '../components/DateRangePickerInput'

const SpecialIntervalsListForm = (props) => {
    const { fields, t } = props

    const columns = [
        {
            key    : 'date',
            title  : t('Date Interval'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].date` }
                    placeholder={ t('Interval') }
                    component={ DateRangePickerInput }
                    size={ ui.SIZE.small }
                />
            )
        },
        {
            key    : 'startTime',
            title  : t('Opening Hours'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].startTime` }
                    placeholder={ t('Opening Hours') }
                    component={ TimePickerInput }
                    size={ ui.SIZE.small }
                />
            )
        },
        {
            key    : 'stopTime',
            title  : t('Closing Hours'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].stopTime` }
                    placeholder={ t('Closing Hours') }
                    component={ TimePickerInput }
                    size={ ui.SIZE.small }
                />
            )
        },
        {
            key    : 'price',
            title  : t('Price'),
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Field
                    name={ `${fields.name}[${index}].price` }
                    placeholder={ t('Price') }
                    component={ Input }
                    size={ ui.SIZE.small }
                />
            )
        },
        {
            key    : 'delete',
            render : ({ index }) => ( // eslint-disable-line react/prop-types
                <Button
                    onClick={ () => fields.remove(index) }
                    intent={ ui.INTENT.danger }
                    icon="md/delete"
                    isRounded
                />
            )
        }
    ]

    return (
        <Panel
            title={ t('Special Intervals / Holidays') }
            hasTable
            withDivider
        >
            <Table
                columns={ columns }
                data={ fields.getAll() }
                withBorders={ false }
                footer={ (
                    <Button
                        label={ t('Add Interval') }
                        icon="md/add"
                        size={ ui.SIZE.default }
                        intent={ ui.INTENT.primary }
                        onClick={ () => fields.push({
                            date: {
                                startDate : new Date(),
                                endDate   : new Date()
                            },
                            startTime : '00:00:00',
                            stopTime  : '23:59:59'
                        }) }
                        isRounded
                    />
                ) }
            />
        </Panel>
    )
}

SpecialIntervalsListForm.propTypes = {
    fields: PropTypes.object.isRequired
}

export default translate()(SpecialIntervalsListForm)
